/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'
import LoginServiceMixin from '@/services/LoginServiceMixin'
import {LoginService} from '@/services/LoginService'
import MessageBox from '@/components/shared/MessageBox'
import PasswordInput from '@/components/shared/PasswordInput'
import {ERROR_MESSAGE_TYPE, SUCCESS_MESSAGE_TYPE} from '@/utils/constants'

@Component({
    mixins: [LoginServiceMixin],
    components: {
            MessageBox,
            PasswordInput,
        },
})

export default class Login extends Vue {

    private email: string = ''
    private password: string = ''
    private loginService: LoginService // redeclared variable to avoid warnings in Webstorm
    private messageType = SUCCESS_MESSAGE_TYPE

    @Prop()
    private message: string

    private currentMessage = this.message

    private clearCurrentMessage() {
        this.currentMessage = ''
    }

    public mounted() {
        //console.log("mounted")
        try {
            this.login_okta()
        } catch (e){
            console.log("error login_okta")
        }
    }

    private async login(): Promise<void> {
        if (this.email.length === 0 || this.password.length === 0) {
            this.currentMessage = 'Email address and password are mandatory'
            this.messageType = ERROR_MESSAGE_TYPE
            return
        }

        try {
            const user = await this.loginService.login(this.email, this.password)
            this.$store.commit('setCurrentUser', user)
            this.$router.push({name: 'analysislist'})
        } catch (e) {
            this.messageType = ERROR_MESSAGE_TYPE
            if (e.errorStatusCode === 401) {
                this.currentMessage = e.errorTitle
            } else {
                this.currentMessage = 'Login failed. ' + e.errorMessage
            }
        }
    }

    private async login_okta(): Promise<void> {
        try {
            //console.log("login_okta 01")
            const user = await this.loginService.login_okta()
            //console.log("login_okta 02")
            //console.log(user)
            this.$store.commit('setCurrentUser', user)
            //console.log("login_okta 03")
            this.$router.push({name: 'analysislist'})
            //console.log("login_okta 04")
        } catch (e) {
            console.log("login_okta error ")
            //console.log(e)
            //this.messageType = ERROR_MESSAGE_TYPE
            //if (e.errorStatusCode === 401) {
            //    this.currentMessage = e.errorTitle
            //} else {
            //    this.currentMessage = 'Login failed. ' + e.errorMessage
            //}
        }
    }
}
